module.exports = __webpack_public_path__ + "static/media/orders.8db80466.svg";